import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator";
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator";


export class Taxwd {
    @MaxLength(10,{message: 'COMPANY 字串太長'})
    @IsString({message: 'COMPANY 不是字串型態'})
    COMPANY: string = "";

    @MaxLength(10)
    CREATOR: string = "";

    @MaxLength(10)
    USR_GROUP: string = "";

    @MaxLength(8)
    CREATE_DATE: string ="";

    @MaxLength(10)
    MODIFIER: string = "";

    @MaxLength(8)
    MODI_DATE: string = "";

    @IsNumber()
    @Max(999)
    FLAG: number =0;


    @IsNotEmpty({message: '發票號碼 (WD001) 不可空白'})
    @MaxLength(20,{message: '發票號碼 (WD001) 資料太長'})
    WD001: string = '';            // 發票號碼 20 InvoiceNumber

    @IsNotEmpty({message: '訊息類別 (WD002) 不可空白'})
    @MaxLength(5,{message: '訊息類別 (WD002) 資料太長'})
    WD002: string = '';            // 訊息類別 5 A0101, A0102, A0201, A0202, A0301, A0302, A0401, A0501, A0601, B0101, B0102, B0201, B0202, B0401, B0501, C0401, C0501, C0701, D0401, D0501, E0401, E0402, E0501

    @IsNotEmpty({message: '申報年月 (WD003) 不可空白'})
    @MaxLength(6,{message: '申報年月 (WD003) 資料太長'})
    WD003: string = '';            // 申報年月 6 COPY(WC007,1,6)

    @IsNotEmpty({message: '序號 (WD004) 不可空白'})
    @MaxLength(4,{message: '序號 (WD004) 資料太長'})
    WD004: string = '';            // 序號 4 SequenceNumber [1] [1..999] AllowanceSequenceNumber

    @MaxLength(10,{message: '發票起號 (WD005) 資料太長'})
    WD005: string = '';            // 發票起號 10 E0401 InvoiceBeginNo 原發票日期:OriginalInvoiceDate

    @MaxLength(10,{message: '發票迄號 (WD006) 資料太長'})
    WD006: string = '';            // 發票迄號 10 E0401 InvoiceEndNo  課稅別:TaxType

    @MaxLength(120,{message: '品名 (WD007) 資料太長'})
    WD007: string = '';            // 品名 120 Description [1] OriginalDescription

    @IsNumber()
    WD008: number = 0;            // 數量 11.3 Quantity  [1]

    @IsNumber()
    WD009: number =  0;            // 單價 21.6 UnitPrice [1]   原幣報價

    @IsNumber()
    WD010: number =  0;            // 金額 12 Amount [1]

    @MaxLength(255,{message: '備註 (WD011) 資料太長'})
    WD011: string = '';            // 備註 255 Remark [0..1]  若為健康捐請於本項填寫"健康捐"

    @MaxLength(6,{message: '單位 (WD012) 資料太長'})
    WD012: string = '';            // 單位 6 Unit [0..1]

    @MaxLength(20,{message: '相關號碼 (WD013) 資料太長'})
    WD013: string = '';            // 相關號碼 20 RelateNumber[0..1]   OriginalInvoiceNumber

    @IsNumber()
    WD014: number =  0;            // 營業稅額 12 Tax

    @MaxLength(7,{message: '流水號 (WD015) 資料太長'})
    WD015: string = '';            // 流水號 7 原明細排列序號 OriginalSequenceNumber

    @IsNumber()
    WD016: number =  0;            // 原幣金額 21.6 OriginalCurrencyAmount [0..1]   原幣金額

    @MaxLength(4,{message: '銷貨來源單別 (WD017) 資料太長'})
    WD017: string = '';            // 銷貨來源單別 4 TG001

    @MaxLength(20,{message: '銷貨來源單號 (WD018) 資料太長'})
    WD018: string = '';            // 銷貨來源單號 20 TG002

    @MaxLength(4,{message: '結帳來源單別 (WD019) 資料太長'})
    WD019: string = '';            // 結帳來源單別 4 TA001

    @MaxLength(20,{message: '結帳來源單號 (WD020) 資料太長'})
    WD020: string = '';            // 結帳來源單號 20 TA002

    @IsNotEmpty({message: '傳送或接收 (WD090) 不可空白'})
    @MaxLength(1,{message: '傳送或接收 (WD090) 資料太長'})
    WD090: string = '1';            // 傳送或接收 1 [DEF:"1"] {{1:傳送 2:接收}} (CASE WC090 WHEN '1' THEN '1:傳送' WHEN '2' THEN '2:接收' END) AS 傳送或接收


}
